<template lang="pug">

    table.ui.price.striped.table

        thead
            tr
                th.one.wide  
                th.one.wide(v-bind:v-tooltip="'Lieferanten dem Kunden anzeigen'") Pub.
                th.six.wide Lieferant
                th.two.wide HK + Versand
                th.two.wide Verkaufspreis
                th.two.wide DB gesamt
                th.two.wide Pr. anz.

        tbody
            tr(
                is='price-table-row'
                v-for='priceModel in priceModels'
                v-bind:key='priceModel.id'
                v-bind:additional-cost-models='getAdditionalCostModelsByPriceModel(priceModel)'
                v-bind:price-model='priceModel'
                v-bind:product-model='productModel'
                v-bind:supplier-model='getSupplierModelByPrice(priceModel)'
            )

</template>

<script>
    import * as R from 'ramda'
    import PriceTableRow from './PriceTableRow'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { PriceTableRow },

        methods: {

            getAdditionalCostModelsByPriceModel(priceModel) {
                return R.filter(
                    R.propEq('price', priceModel.id),
                    this.additionalCostModels
                )
            },

            getJobModelByOfferModel(offerModel) {
                return R.find(R.propEq('id', offerModel.job), this.jobModels)
            },

            getOfferModelByPriceModel(priceModel) {
                return R.find(R.propEq('id', priceModel.offer), this.offerModels)
            },

            getSupplierModelByPrice(priceModel) {
                return R.compose(
                    // Lieferanten suchen
                    this.getSupplierModelByJobModel,

                    // Job holen
                    this.getJobModelByOfferModel,

                    // Angebot holen
                    this.getOfferModelByPriceModel
                )(priceModel)
            },

            getSupplierModelByJobModel(jobModel) {
                return R.find(R.propEq('id', jobModel.supplier), this.supplierModels)
            }

        },

        props: {

            additionalCostModels: {
                type: Array,
                required: true
            },

            jobModels: {
                type: Array,
                required: true
            },

            offerModels: {
                type: Array,
                required: true
            },

            priceModels: {
                type: Array,
                required: true
            },

            productModel: {
                type: Object,
                required: true
            },

            supplierModels: {
                type: Array,
                required: true
            }

        }

    }

</script>
